module.exports = __webpack_public_path__ + "static/media/1-1.98a104b2.mp3";